import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAuth0 } from '@auth0/auth0-angular';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { initializeBranding } from './core/initializers/branding.initializer';
import { initializeUser } from './core/initializers/user.initializer';
import { BrandingService } from './shared/services/branding/branding.service';
import { UserService } from './core/services/user.service';
import { AuthService } from './core/auth/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([apiInterceptor])
    ),
    provideAuth0({
      ...environment.auth0,
      // Skip Auth0 initialization if anonymous login flag is present
      skipRedirectCallback: typeof window !== 'undefined' && localStorage.getItem('anonymous_login') === 'true',
      // Use cache location 'localstorage' to prevent Auth0 from making unnecessary requests
      cacheLocation: 'localstorage' as any,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBranding,
      deps: [BrandingService, UserService, AuthService],
      multi: true
    },
    // Theme initializer disabled - now using BrandingService initializer instead
    // ThemeService was loading /api/theme/{slug} which returns 404, then falling back to defaults
    // This was overriding the branding applied by BrandingService
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeTheme,
    //   deps: [ThemeService],
    //   multi: true
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUser,
      deps: [UserService],
      multi: true
    }
  ]
};
